module.exports = __webpack_public_path__ + "img/scratch_bg.b2b1a3c4.png";